import React, {useEffect, useRef } from 'react';
import '../App.css';
import './footer.css';
import 'aos/dist/aos.css';
import Grid from '@material-ui/core/Grid';

import twitterf from '../img/twitter.png';





function Attributes() {
  return (
            <>
                <div id='footer' className='footer'>
               
                        <a href='https://twitter.com/1nner_circle?t=FzAJ8ASbeg8twQSUBskj_w&s=08'  target='_blank'><div className='iconFooterbox'>
                                <img className='footerIcon' src={twitterf} alt="footer-twitter" />
                            </div></a>
                       
                          
                </div>
            </>

  );
}

export default Attributes;
